
    import Vue from 'vue';
    import Component from "vue-class-component";
    import LabelOptional from "@/features/shared/components/LabelOptional.vue";
    import SectionPageHeading from "@/features/shared/components/sections/SectionPageHeading.vue";
    import FileUploader from "@/components/FileUploader.vue";
    import {
        EducationalInstitution,
        QualificationActions,
        ResultError,
        TrainingQualificationModel,
        TrainingQualificationOptions,
        TrainingType
    } from "@/api-client";
    import {Prop} from "vue-property-decorator";
    import Loader from "@/features/shared/components/Loader";
    import CheckboxInput from "@/features/shared/components/CheckboxInput.vue";
    import toasts from "@/components/Toasts";
    import userInfo from "@/features/shared/components/UserInfo";
    import Files from "@/components/Files.vue";
    import moment from "moment";

    @Component({
        components: {
            LabelOptional,
            SectionPageHeading,
            FileUploader,
            Files,
            CheckboxInput
        }
    })
    export default class TrainingQualificationUpsertForm extends Vue {
        @Prop({ required: true })
        seafarerId!: string;

        @Prop({ required: true })
        qualificationPreloadedActions!: QualificationActions;

        @Prop({ required: true })
        model!: TrainingQualificationModel;

        @Prop({ required: true })
        options!: TrainingQualificationOptions;

        @Prop({required: true})
        submitCallback!: (model: TrainingQualificationModel) => Promise<void>;

        trainingTypes = TrainingType;
        validationErrors = ResultError.createEmpty();
        isEducationalInstitutionNameEnteredManually: boolean =
            !this.model.educationalInstitutionId && !!this.model.educationalInstitutionName; // Name is defined but not ID.
        selectedInstitution: EducationalInstitution | null = null;
        fileLoader = new Loader();
        submitLoader = new Loader();
        isSeafarer = userInfo.seafarerId === this.seafarerId;

        async created() {
            this.$watch(
                () => this.isEducationalInstitutionNameEnteredManually,
                () => {
                    if (this.isEducationalInstitutionNameEnteredManually) {
                        this.setSelectedInstitution(null);
                    } else {
                        this.options.educationalInstitutions = this.options.educationalInstitutions.filter(e => e.active);
                        this.setSelectedInstitution(this.options.educationalInstitutions[0]);
                    }
                }, { immediate: true });

            this.$watch(() => this.model, () => {
                if(this.model.issuedOn && moment().startOf("day").diff(this.model.issuedOn) < 0){
                    this.validationErrors.clearKey("issuedOn");
                    this.validationErrors.appendMessage(this.$ls.Global_IssuedOn_In_The_Future,"issuedOn");
                }
                else{
                    this.validationErrors.clearKey("issuedOn");
                }
                if(this.model.issuedOn && this.model.validUntil){
                    if(moment(this.model.validUntil).diff(this.model.issuedOn) <= 0){
                        this.validationErrors.clearKey("validUntil");
                        this.validationErrors.appendMessage(this.$ls.Global_ValidUntil_Before_IssuedOn,"validUntil");
                    }
                    else{
                        this.validationErrors.clearKey("validUntil");
                    }
                }
                if(this.model.issuedOn && this.model.fulfillmentDate){
                    if(moment(this.model.fulfillmentDate).diff(moment(this.model.issuedOn).endOf("day")) > 0){
                        this.validationErrors.clearKey("fulfillmentDate");
                        this.validationErrors.appendMessage(this.$ls.Global_FulfillmentDate_After_IssuedOn,"fulfillmentDate");
                    }
                    else{
                        this.validationErrors.clearKey("fulfillmentDate");
                    }
                }

            },{ deep: true });
        }
        setSelectedInstitution(institution: EducationalInstitution | null) {
            this.selectedInstitution = institution;
            this.model.educationalInstitutionId = institution?.id;
        }

        async submit(e:any) {
          this.submitLoader.startLoading();
            this.validationErrors.clear();
            await this.submitCallback(this.model)
                .then(async () => {
                    toasts.success(this.$ls.Documents_Qualifications_Toast_Success_DocumentSaving);
                })
                .catch(error => this.setValidationErrors(error, this.$ls.Global_Toast_FormSaveFailure));
          this.submitLoader.endLoading();
        }
    }
